import classes from "./classes.module.scss";
import { useCallback } from "react";
import { BlockBody, getBlockBadgeThemeKey, type BlockContentProps } from "./BlockBody";
import { useBlockOfficeAccentBorder } from "./useBlockOfficeAccentBorder";

export type IBlock = {
	id: string;
	primaryText: string;
	secondaryText?: string;
	tertiaryText?: string; // Nom de l'office (16 caractères max)
	statusBadge?: string; // Badge de statut (ex: "Archivé", "Supprimé")
	showAlert?: boolean;
	isActive?: boolean;
	officeColor?: string; // Couleur unique par office (TODO17)
};

type IProps = IBlock & {
	hasSeparator?: boolean;
	onClick?: (id: string) => void;
};

export default function Block(props: IProps): React.JSX.Element {
	const { primaryText, secondaryText, tertiaryText, statusBadge, showAlert = false, hasSeparator = true, isActive = false, onClick, officeColor } = props;
	const handleOnClick = useCallback(() => onClick && onClick(props.id), [onClick, props.id]);
	const rootRef = useBlockOfficeAccentBorder(officeColor);
	const badgeThemeKey = getBlockBadgeThemeKey(statusBadge);
	const contentProps: BlockContentProps = {
		primaryText,
		secondaryText,
		tertiaryText,
		statusBadge,
		showAlert,
		hasSeparator,
		isActive,
		badgeThemeKey,
	};
	const inner = <BlockBody contentProps={contentProps} />;
	if (onClick) {
		return (
			<button
				type="button"
				ref={rootRef as React.RefObject<HTMLButtonElement>}
				className={classes["root"]}
				data-is-active={isActive}
				onClick={handleOnClick}>
				{inner}
			</button>
		);
	}
	return (
		<div ref={rootRef as React.RefObject<HTMLDivElement>} className={classes["root"]} data-is-active={isActive}>
			{inner}
		</div>
	);
}
